import './Spinner.scss';
import React from 'react';
import { Spin } from 'antd';

const Spinner: React.SFC<{ 
  style?: string;
  height?: 'md' | 'lg';
}> = ({ 
  style = '',
  height = 'none',
}) => (
  <div className={ `spinner ${ style } h-${ height }` }>
    <Spin size='large' />
  </div>
);

export default Spinner;


// WEBPACK FOOTER //
// ./src/components/Shared/Spinner/Spinner.tsx